import { render, staticRenderFns } from "./BillingKinds.vue?vue&type=template&id=34db3fc4"
import script from "./BillingKinds.vue?vue&type=script&lang=js"
export * from "./BillingKinds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports